export type TranslationEntry = {
  exists?: boolean
  id?: number
  locale?: string
  hreflang?: string
  slug?: string
  link?: string
  relativeUrl?: string
}

export type TranslationsMap = Record<string, TranslationEntry>

type RawTranslationEntry = {
  exists?: unknown
  id?: unknown
  locale?: unknown
  hreflang?: unknown
  slug?: unknown
  link?: unknown
  relative_url?: unknown
}

function toEntry(value: unknown): TranslationEntry | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null

  const raw = value as RawTranslationEntry

  return {
    exists: typeof raw.exists === 'boolean' ? raw.exists : undefined,
    id: typeof raw.id === 'number' ? raw.id : undefined,
    locale: typeof raw.locale === 'string' ? raw.locale : undefined,
    hreflang: typeof raw.hreflang === 'string' ? raw.hreflang : undefined,
    slug: typeof raw.slug === 'string' ? raw.slug : undefined,
    link: typeof raw.link === 'string' ? raw.link : undefined,
    relativeUrl: typeof raw.relative_url === 'string' ? raw.relative_url : undefined,
  }
}

export function normalizeTranslations(value: unknown): TranslationsMap | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return undefined

  const entries = Object.entries(value).reduce<TranslationsMap>((acc, [key, entry]) => {
    const normalizedEntry = toEntry(entry)
    if (!normalizedEntry) return acc

    acc[key] = normalizedEntry
    return acc
  }, {})

  return Object.keys(entries).length > 0 ? entries : undefined
}
